/* Shared report chrome — used by ReportPage and by the deferred sections it does not
   currently compose (ReportSectionsDeferred.tsx). */

import React from 'react';
import { Card, Typography } from 'antd';

/* Explicit hex rather than theme tokens: these are read on paper as often as on screen, and a
   print stylesheet cannot resolve AntD's runtime CSS variables. Green is the brand primary,
   the rest are AntD's semantic scale at print-safe darkness. */
export const TONE = {
  primary: '#388E3C',
  success: '#389e0d',
  warning: '#d48806',
  danger: '#cf1322',
  muted: '#8c8c8c',
} as const;
export type Tone = keyof typeof TONE;

/** Section heading with the green rule the report uses throughout — same as the PDF's. */
export const SectionTitle: React.FC<{ icon?: React.ReactNode; children: React.ReactNode }> = ({ icon, children }) => (
  <Typography.Title
    level={5}
    style={{
      color: TONE.primary,
      borderBottom: `2px solid ${TONE.primary}`,
      paddingBottom: 8, marginBottom: 16, marginTop: 0,
    }}
  >
    {icon}{icon ? ' ' : ''}{children}
  </Typography.Title>
);

/** Compact stat tile. Card + explicit colour so it survives print. */
export const StatTile: React.FC<{ label: string; value: React.ReactNode; tone: Tone; icon?: React.ReactNode }> = ({
  label, value, tone, icon,
}) => (
  <Card size="small" styles={{ body: { padding: '12px 8px', textAlign: 'center' } }} style={{ height: '100%', borderColor: TONE[tone] }}>
    {icon && <div style={{ color: TONE[tone], fontSize: 18, marginBottom: 2 }}>{icon}</div>}
    <div style={{ color: TONE[tone], fontWeight: 700, fontSize: 20, lineHeight: 1.2 }}>{value}</div>
    <div style={{ color: TONE.muted, fontSize: 12, marginTop: 2 }}>{label}</div>
  </Card>
);

